<template>
    <div>
        <div class="tips">商城原始微信订单，仅用于查询历史微信下单记录；ERP 未同步订单可在此查看。</div>
        <tablePagination :total="totalRecord" :currentPage="formInline.currentPage" :pageSize="formInline.pageSize" @handlePage="handlePage">
            <el-table border :data="orderList" size="mini" v-loading="loading">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column label="订单号" min-width="220">
                    <template slot-scope="scope">
                        <div class="line-main">
                            主单: {{ scope.row.orderMainNo }}
                            <i style="color: #55a532;cursor: pointer" @click="copyText(scope.row.orderMainNo)" class="el-icon-document-copy"></i>
                        </div>
                        <div class="line-sub" v-if="scope.row.orderNo">
                            子单: {{ scope.row.orderNo }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="订单信息" min-width="150">
                    <template slot-scope="scope">
                        <div>下单: {{ formatDate(scope.row.createTime) || '-' }}</div>
                        <div>状态: {{ scope.row.statusName || '-' }}</div>
                        <div>来源: {{ scope.row.orderSourceName || '-' }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="金额信息" min-width="140">
                    <template slot-scope="scope">
                        <div>订单: {{ formatMoney(scope.row.orderAmount) }}</div>
                        <div>支付: {{ formatMoney(scope.row.payAmount) }}</div>
                        <div>余额: {{ formatMoney(scope.row.balanceAmount) }}</div>
                        <div>优惠券: {{ formatMoney(scope.row.couponAmount) }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="收货信息" min-width="220">
                    <template slot-scope="scope">
                        <div>{{ scope.row.consigneeName || '-' }} / {{ scope.row.consigneePhone || '-' }}</div>
                        <div>{{ scope.row.consigneeAddress || '-' }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="productSummary" label="商品摘要" min-width="240"></el-table-column>
            </el-table>
        </tablePagination>
    </div>
</template>

<script>
import tablePagination from '@c/tablePagination'

export default {
    data() {
        return {
            loading: false,
            orderList: [],
            totalRecord: 0,
            formInline: {
                customerId: this.$route.params.id,
                currentPage: 1,
                pageSize: 15
            }
        }
    },
    components: {
        tablePagination
    },
    mounted() {
        this.initList()
    },
    methods: {
        initList() {
            this.loading = true
            this.$apiGet('lechun-customers/customerMallOrder/getWxOrderList', this.formInline).then(res => {
                this.loading = false
                this.totalRecord = res.total || 0
                this.orderList = res.list || []
            }).catch(() => {
                this.loading = false
            })
        },
        handlePage(page) {
            this.formInline.currentPage = page
            this.initList()
        },
        copyText(text) {
            var input = document.createElement('textarea')
            input.value = text
            document.body.appendChild(input)
            input.select()
            document.execCommand('Copy')
            document.body.removeChild(input)
            this.$message({
                type: 'success',
                message: '已复制到剪贴板'
            })
        },
        formatDate(datetime) {
            if (!datetime) {
                return ''
            }
            return new Date(datetime).Format('yyyy-MM-dd hh:mm:ss')
        },
        formatMoney(value) {
            if (value === null || value === undefined || value === '') {
                return '-'
            }
            return value
        }
    }
}
</script>

<style scoped>
.tips{
    margin-bottom: 10px;
    color: #909399;
    font-size: 12px;
}
.line-main{
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 6px;
}
.line-sub{
    font-size: 12px;
    color: #606266;
}
</style>
